import { IOrganisation, queryKeys } from '../../shared';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { useItem, UseItemParams, useList, UseListParams } from '../../shared/hooks/new-read-only.hook';
import { organisationClient } from '../clients/organisation.client';

const client = organisationClient;
const listKey = queryKeys.ORGANISATIONS;
const itemKey = queryKeys.ORGANISATION;

export function useOrganisationList(...args: UseListParams<IOrganisation>) {
    return useList(client, listKey, args);
}

export function useOrganisation(...args: UseItemParams<IOrganisation>) {
    return useItem(client, itemKey, args);
}

export function useSaveOrganisation() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteOrganisation() {
    return useDelete(client, listKey);
}
